import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';

import 'react-table/react-table.css';

import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';

import { getReferrals, updateReferral } from 'actions/landlordLeadsActions';
import { isFilterInStrings } from 'helpers/StringHelper';
import constants from 'helpers/constants';

import ReferralsTable from './ReferralsTable';
import ReferralsMobile from './ReferralsMobile';
import ReferralReviewDialog from './ReferralReviewDialog';

export default connect(
  store => ({
    referrals: store.landlordLeads.referrals,
  }),
  dispatch => ({
    getReferrals: () => dispatch(getReferrals()),
    updateReferral: (id, isComplete) => dispatch(updateReferral(id, isComplete)),
  })
)(
  class LandlordReferrals extends Component {
    state = {
      filterText: '',
      filterClosed: false,
      dialogOpen: false,
      dialogData: {},
    };

    UNSAFE_componentWillMount() {
      this.props.getReferrals();
    }

    updateReferral = (id, isComplete) => {
      this.props.updateReferral(id, isComplete).then(() => {
        this.toggleDialog();
        this.props.getReferrals();
      });
    };

    toggleDialog = dialogData => {
      dialogData = dialogData || this.state.dialogData;
      this.setState({ dialogOpen: !this.state.dialogOpen, dialogData });
    };

    updateFilterType = () => {
      this.setState({ filterClosed: !this.state.filterClosed });
    };

    updateFilterText = e => {
      this.setState({ filterText: e.target.value });
    };

    render() {
      const filteredData = (this.props.referrals || []).filter(item => {
        if (item.status === constants.referrals.DENIED) return false;
        if (
          !this.state.filterClosed &&
          (item.status === constants.referrals.COMPLETED ||
            item.status === constants.referrals.UNSUCCESFUL)
        )
          return false;

        return isFilterInStrings(
          [item.unit_name, item.referrer.unit_name, item.referrer.name],
          this.state.filterText
        );
      });

      return (
        <div className="body" role="main">
          <div className="centers">
            <div className="stage-header clearfix">
              <span className="page-title">Referrals</span>
            </div>

            <div className="row" style={{ marginTop: '-20px' }}>
              <TextField
                hintText="Filter by Referrals"
                style={{ fontSize: '13px' }}
                value={this.state.filterText}
                onChange={this.updateFilterText}
              />
            </div>

            <Toggle
              label="Show All"
              labelPosition="right"
              style={{ marginTop: '10px' }}
              toggled={this.state.filterClosed}
              onToggle={this.updateFilterType}
            />

            <MediaQuery query="(min-device-width: 750px)">
              <ReferralsTable
                referrals={filteredData}
                updateReferral={this.updateReferral}
                toggleDialog={this.toggleDialog}
              />
            </MediaQuery>

            <MediaQuery query="(max-device-width: 750px)">
              <ReferralsMobile
                referrals={filteredData}
                updateReferral={this.updateReferral}
                toggleDialog={this.toggleDialog}
              />
            </MediaQuery>

            <ReferralReviewDialog
              open={this.state.dialogOpen}
              data={this.state.dialogData}
              toggleOpen={this.toggleDialog}
              onSubmit={this.updateReferral}
            />

            <div style={{ height: '100px' }} />
          </div>
        </div>
      );
    }
  }
);
